export const education = [
  {
    year: "۱۳۹۴-۱۳۹۷",
    proof: "دیپلم",
    Major: "رشته ریاضی فیزیک",
    // place: 'شاهد ۱۳',
  },
  {
    year: "۱۳۹۷-۱۴۰۱",
    proof: "کارشناسی",
    Major: "رشته مهندسی کامپیوتر",
    place: "دانشگاه دولتی سلمان فارسی کازرون",
  },
];

export const experiance = [
  {
    year: "از اردیبهشت ۱۴۰۰ تا آذر ۱۴۰۰",
    company: "شرکت توسعه گران جهان رایانه",
    position: "برنامه نویس فرانت اند ",
    work: "طراحی سایت: فروشگاهی ،خبری و شرکتی",
  },
  {
    year: "از آذر ۱۴۰۰ تا ۱۴۰۲ ",
    company: "فریلنسر",
    position: "برنامه نویس فرانت اند ",
    work: "طراحی سایت: فروشگاهی ،خبری و شرکتی",
  },
  {
    year: "از تیر ۱۴۰۲ تا کنون ",
    company: "گروه شرکت های آریسا",
    position: "برنامه نویس فرانت اند ",
    work: "طراحی سایت: فروشگاهی ،خبری و شرکتی",
  },
];
